<template>
	<v-main data-tour-scope="warehouse-outcoming">
		<v-container fluid fill-height>
			<v-layout justify-center align-center>
				<v-card width="100%" outlined elevation-0>
					<v-toolbar flat class="border_bottom" shaped>
						<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.warehouse.home') }} / {{ this.$vuetify.lang.t('$vuetify.front.warehouse.outcoming') }}</v-toolbar-title>
						<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()">
							<v-icon left>mdi-school-outline</v-icon>
							Tutorial guidato
						</v-btn>

						<v-spacer></v-spacer>
					</v-toolbar>

					<v-container>
						<v-alert outlined text type="info"> Usare il lettore barcode per leggere i codici dei prodotti </v-alert>
						<v-row>
							<v-col sm="8" offset-md="2" data-tour="scan">
								<v-text-field hide-details="auto" readonly outlined append-icon="mdi-barcode" v-model="sku"></v-text-field>
								<qr-scan-panel class="mt-2 mb-2" data-tour="phone" @code="processScan" />
							</v-col>
						</v-row>
						<div v-if="sku">
							<div v-if="getElement.length === 0">
								<v-alert outlined text type="error"> Nessun prodotto trovato per questo codice</v-alert>
							</div>
							<div v-else>
								<template v-if="getElement.length === 1">
									<v-alert outlined text type="success" data-tour="done"> Aggiornamento avvenuto con successo</v-alert>
								</template>
								<!-- telefono: ogni prodotto trovato diventa una card chiave/valore -->
								<div v-if="mobileCards" class="kv-list" data-tour="table">
									<key-value-card v-for="item in getElement" :key="item.name" :title="item.trans.name" :image="getImage(item) || ''" :fields="campiCard(item)">
										<template v-if="getElement.length > 1">
											<v-btn x-large block color="success" dark style="height: auto" data-tour="choose" @click="updateinventory(item.variants._id, item?.variants?.ean, item?._id)">
												EAN <v-img :src="item.ean" class="mt-2 mb-2 ml-5"></v-img
											></v-btn>
											<v-btn x-large block color="info" dark class="mt-3" style="height: auto" @click="updateinventory(item.variants._id, item?.variants?.sku, item?._id)">
												SKU <v-img :src="item.sku" class="mt-2 mb-2 ml-5"></v-img
											></v-btn>
										</template>
									</key-value-card>
								</div>
								<v-simple-table v-else data-tour="table">
									<thead>
									<tr>
										<th class="text-left">Image</th>
										<th class="text-left">Name</th>
										<th class="text-left">Variante</th>
										<th class="text-left">Qt</th>
										<!--											<th class="text-left">Qt x unità</th>-->
										<template v-if="getElement.length > 1">
											<th class="text-left">Azione</th>
										</template>
									</tr>
									</thead>
									<tbody>
									<tr v-for="item in getElement" :key="item.name">
										<td>
											<template v-if="getImage(item)">
												<img :src="getImage(item)" style="height: 100px"/>
											</template>
										</td>
										<td>
											<span>{{ item.trans.name }}</span><br/>
											<small>{{ (item?.variants?.sku) ? 'SKU: '+item?.variants?.sku + ' - ' :'' }} {{ (item?.variants?.sku) ? 'EAN: '+item?.variants?.ean :'' }}</small>
										</td>
										<td>
											<v-chip v-for="el in item.variants?.variants" v-if="item.variants?.variants?.length > 0" :key="el._id" :ripple="false" class="mr-2 mb-2" small>
												<b class="mr-2">{{ el.name.trans }}</b> {{ el.value.trans }}
											</v-chip>
										</td>
										<td>{{ item?.variants?.qt }}</td>
										<!--											<td>{{ item?.variants?.qtunit }}</td>-->
										<template v-if="getElement.length > 1">
											<td>
												<p>
													<v-btn x-large color="success" dark class="mt-3" style="height: auto" data-tour="choose" @click="updateinventory(item.variants._id, item?.variants?.ean, item?._id)">
														EAN <v-img :src="item.ean" class="mt-2 mb-2 ml-5"></v-img
													></v-btn>
												</p>
												<p>
													<v-btn x-large color="info" dark class="mt-3" style="height: auto" @click="updateinventory(item.variants._id, item?.variants?.sku, item?._id)">
														SKU <v-img :src="item.sku" class="mt-2 mb-2 ml-5"></v-img
													></v-btn>
												</p>
											</td>
										</template>
									</tr>
									</tbody>
								</v-simple-table>
							</div>
						</div>
					</v-container>
				</v-card>
			</v-layout>
		</v-container>

		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</v-main>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import Table from '@/components/orders/Table.vue';

import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import QrScanPanel from '@/components/warehouse/QrScanPanel.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createWarehouseOutcomingTourSteps } from './warehouse-outcoming-tour';

export default {
	name: 'WarehouseOutcoming',
	components: { Table, TourOverlay, QrScanPanel, KeyValueCard },
	/*
	 * Il controller del tutorial nasce qui e non in `data()`: quello che sta in
	 * `data()` viene reso reattivo in profondita da Vue 2, e in quel passaggio i
	 * `ref` del motore verrebbero srotolati nel loro valore grezzo.
	 */
	setup() {
		return {
			tour: useTour(createWarehouseOutcomingTourSteps()),
		};
	},

	data() {
		return {
			pathPrint: '/packing-list/print/',
			isLoading: false,
			coupon_checkbox: true,
			form: {},
			order: {},
			qty: 0,
			code: '',
			reading: false,
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			sku: '',
		};
	},
	async created() {
	},
	computed: {
		...mapGetters({
			getOperator: 'packingLists/getOperator',
			getPackingList: 'packingLists/getPackingList',
			getProfile: 'profile/getId',
			getElement: 'warehouse/getItems',
		}),
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
	},
	methods: {
		...mapMutations({
			setPreload: 'settings/setPreload',
			setDialog: 'settings/setDialog',
			setElement: 'warehouse/setItems',
		}),
		...mapActions({
			getItems: 'warehouse/subItem',
			destroyItems: 'warehouse/destroyData',

			editItem: 'packingLists/edit',
			updateItem: 'warehouse/subUpdateItem',
			resetItem: 'packingLists/reset',
			createBarcodeOrder: 'barcode/createBarcodeOrder',
			addNotyfy: 'notify/addNotify',
		}),
		close() {
			this.setDialog(false);
			this.$emit('message', 'refresh');
		},
		async updateinventory(id, value, itemid) {
			await this.setPreload(true);
			await this.updateItem({ code: id, itemid: itemid });
			await this.setPreload(false);
		},

		async onKeypress(event) {
			if (event.keyCode === 13) {
				await this.processScan(this.code);
			} else {
				this.sku = '';
				this.code += event.key;
			}
		},

		// Unico punto di ingresso dei codici letti: pistola USB (Invio) e telefono (QrScanPanel).
		async processScan(code) {
			this.code = code;
			await this.setPreload(true);
			await this.getItems({ search: this.code });
			this.sku = this.code;
			this.code = '';
			await this.setPreload(false);
		},
		// coppie chiave/valore della card del prodotto letto (vista telefono)
		campiCard(item) {
			const variante = (item?.variants?.variants || []).map((el) => `${el.name?.trans}: ${el.value?.trans}`).join(', ');
			return [
				{ label: 'SKU', value: item?.variants?.sku },
				{ label: 'EAN', value: item?.variants?.ean },
				{ label: 'Variante', value: variante },
				{ label: 'Qt', value: item?.variants?.qt, strong: true },
			];
		},
		getImage(item){
			let variant_id = item.variants?._id
			if(variant_id){
				let variant_ids = item.variants?.variants.map(item => item._id)
				let image = item.images.find((el)=> el.variants.includes(variant_id) || variant_ids.filter(item => el.variants.includes(item)).length > 0)
				if(image){
					return image.sizes[0]?.value
				}else {
					return false
				}
			}else {
				return false
			}
		},
	},
	mounted() {
		this.setElement([]);
		document.addEventListener('keypress', this.onKeypress);
	},
	beforeDestroy() {
		// Se si lascia la pagina a giro aperto, vanno staccati i listener del tutorial.
		this.tour.stop();
		document.removeEventListener('keypress', this.onKeypress);
	},
};
</script>

<style scoped>
/* card in lista fuori da v-data-table */
.kv-list > .kv-card + .kv-card {
	margin-top: 8px;
}
</style>
